import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-library-support',
    templateUrl: './library-support.component.html',
    styleUrls: ['./library-support.component.scss'],
    standalone: false
})
export class LibrarySupportComponent implements OnInit {

 isLandingPage = true;
 activeTab: string = '';
  backgroundColorSideMenu: any;

  constructor(private router: Router,
     private route: ActivatedRoute,
    private localStorage: LocalStorageSettingsService,) {}

  ngOnInit() {
    this.backgroundColorSideMenu = this.localStorage.getSettings("ColorC");
    this.updateActiveTab();
  }

go(route: string) {
  this.activeTab = route;
  this.isLandingPage = false;
  this.router.navigate([route], { relativeTo: this.route });
}
  updateActiveTab() {
    // Example URL: user/Menubar/librarysupport/productlibrary/details/V1000000000K2001
    const segments = this.router.url.split('/').filter(Boolean);
    console.log(segments);

    // segments[2] = 'librarysupport'
    // segments[3] = first child (productlibrary OR studylibrary OR dynamic future tabs)
    this.activeTab = segments[3] || '';
  }

}
